import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20floating%20comic%20book%20pages%20and%20colorful%20panels%20scattered%20artistically%2C%20warm%20dark%20atmosphere%20with%20soft%20glowing%20accents%2C%20modern%20abstract%20design%2C%20subtle%20warm%20gradient%2C%20cinematic%20mood%2C%20no%20visible%20text%2C%20artistic%20composition&width=1800&height=600&seq=cta-bg-2026&orientation=landscape"
          alt="韩漫在线CTA背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 via-background-950/75 to-background-950/85"></div>
      </div>

      <div className="relative z-10 px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-8">
          <div className="text-center lg:text-left">
            <h2 className="text-2xl md:text-4xl font-bold text-background-50 font-heading leading-tight">
              准备好开始你的
              <span className="text-primary-400">韩漫之旅</span>
              了吗？
            </h2>
            <p className="mt-3 text-sm md:text-base text-background-50/70 max-w-md">
              海量<strong className="text-background-50">免费韩国漫画</strong>等你来发现，立即开始阅读吧
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-3">
            <Link
              to="/category/rexue"
              className="px-8 py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              免费开始阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 text-sm md:text-base font-medium rounded-lg hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}